<script lang="ts">
  export let href: string | undefined = undefined;
</script>

<a class="nav-bar-link" {href} on:click on:keypress>
  <slot />
</a>

<style lang="scss">
  .nav-bar-link {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 10px;

    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
    color: $color-dark-gray;
    cursor: pointer;
  }
  @include mobile {
    .nav-bar-link {
      justify-content: flex-start;
      margin-left: 5vw;
      height: 40px;
    }
  }
</style>
